import React, { Component } from "react";
import { connect } from "react-redux";
import LoadingLoadable from "../../components/LoadingLoadable";
import "react-image-lightbox/style.css";
import { fetchProjectsDetail } from "../../actions/home";
import { fetchprojectVideosById } from "../../actions/projectVideos";
import axios from "axios";
const ProjectMobile = React.lazy(() => import("./ProjectMobile"));
const ProjectInner = React.lazy(() => import("./ProjectInner"));

const wid = window.innerWidth;

class ProjectPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project: {},
      run: true,
      pathId: null,
    };
  }

  getVideoLinks = (id) => {
    const { dispatch } = this.props;
    dispatch(fetchprojectVideosById(id));
  };

  getVideosDataFromProjectName() {
    let videos = [];

    if (this.props.projectsVideos.videoLinks) {
      let detail = this.props.projectsVideos;

      let data = JSON.parse(JSON.parse(detail.videoLinks));

      data.map((item) => {
        videos.push({
          id: detail.projectId,
          type: "video",
          title: "",
          url: item,
        });
      });

      console.log("videos ===> ", videos, detail, detail.projectId, data, typeof data)
    }
    return videos;
  }

  componentDidMount() {
    console.log("componentDidMount Called");
    const path = this.props.data.pathname.split("/");
    this.setState({ pathId: path[2] });
    axios
      .get(`https://www.agency21.com.pk/api/projects/Details/${path[2]}`)
      .then((res) => this.setState({ project: res.data }));

    const { dispatch } = this.props;
    dispatch(fetchProjectsDetail(path[2]));
console.log("ahsb",path,this.props.match);
    this.getVideoLinks(path[2]);
  }

  componentDidUpdate() {
    const path = this.props.data.pathname.split("/");
//image reloading problem might be here
    console.log("componentDidUpdate Called");
    if (this.state.run) {
      axios
        .get(`https://www.agency21.com.pk/api/projects/Details/${path[2]}`)
        .then((res) => this.setState({ project: res.data }));

      const { dispatch } = this.props;
      dispatch(fetchProjectsDetail(path[2]));

      this.setState({ run: false });
    }
  }

  render() {
    const data = this.state.project;
    const updatedVideos = this.getVideosDataFromProjectName(
      data.alternative_name
    );
    const updatedData = { ...data, videos: updatedVideos };
    // console.log("============> ",updatedVideos);
    return (
      <React.Fragment>
        {Object.keys(data).length !== 0 ? (
          <div>
            {wid > 991 && (
              <div>
                {" "}
                <ProjectInner project={updatedData} {...this.props} />
              </div>
            )}
            {wid <= 991 && (
              <div>
                <ProjectMobile project={updatedData} {...this.props} />
              </div>
            )}
          </div>
        ) : (
          <LoadingLoadable />
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  // console.log("state here ==> ", state)
  return {
    projectsVideos: state.projectVideos.data,
    projects: state.home.projects,
  };
};

export default connect(mapStateToProps)(ProjectPage);
